export default "__VITE_ASSET__52cfd960__"